import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { OrganizationPayeeIdSchema } from './organization.models.ts'
import { EmailAddressSchema } from './property.models.ts'

// MM/DD/YYYY hh:mm:ss.fff
const parseIpnDate = (dateString: string): Date => {
  const [datePart, timePart] = dateString.split(' ')

  if (!(datePart && timePart)) {
    throw new Error(`Invalid date string: ${dateString}`)
  }

  const [month, day, year] = datePart.split('/')

  if (!(month && day && year)) {
    throw new Error(`Invalid date string: ${dateString}`)
  }

  return new Date(`${year}-${month}-${day}T${timePart}Z`)
}

// A schema that excludes sensitive bank info fields
export const TipaltiWebhookRedactedPayloadSchema = z
  .object({
    key: z.string(),
    c_date: z.string(),
    is_test: z.string(),
    type: z.string(),
    payee_id: z.string(),
    email: z.string(),
    is_payable: z.string(),
  })
  .partial()

export type TipaltiWebhookRedactedPayload = ZodSimplify<
  typeof TipaltiWebhookRedactedPayloadSchema
>

const TipaltiWebhookCommonPayloadSchema = z.object({
  key: z.string(),
  c_date: z.string().transform(parseIpnDate),
  is_test: z
    .enum(['True', 'False'])
    .transform((data) => data === 'True')
    .optional(),
})

export const TipaltiWebhookPayeeDetailsChangedPayloadSchema =
  TipaltiWebhookCommonPayloadSchema.extend({
    type: z.enum(['payee_details_changed']),
    payee_id: OrganizationPayeeIdSchema,
    email: EmailAddressSchema,
    is_payable: z.enum(['True', 'False']).transform((data) => data === 'True'),
  })

export type TipaltiWebhookPayeeDetailsChangedPayload = ZodSimplify<
  typeof TipaltiWebhookPayeeDetailsChangedPayloadSchema
>

export const TipaltiWebhookPayloadSchema = z.discriminatedUnion('type', [
  TipaltiWebhookPayeeDetailsChangedPayloadSchema,
])

export type TipaltiWebhookPayload = ZodSimplify<
  typeof TipaltiWebhookPayloadSchema
>
